var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm.showCart
      ? _c("div", {
          attrs: { id: "cart-overlay" },
          on: {
            click: function($event) {
              _vm.showCart = false
            }
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "cart-wrapper" }, [
      _vm.showCart
        ? _c("div", { staticClass: "cart-contents container pt-2" }, [
            _c(
              "div",
              { attrs: { id: "scroll-container" } },
              [
                _c("order-table-cart-component", {
                  attrs: { cartItems: _vm.cart }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "cart-overview py-1" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "toggle-wrapper d-block d-md-none text-center" },
            [
              _c(
                "a",
                {
                  staticClass: "toggle-link text-dark",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      _vm.showCart = !_vm.showCart
                    }
                  }
                },
                [
                  _vm._v("\n                        View Order Details "),
                  _c("span", {
                    staticClass: "fa ml-1",
                    class: {
                      "fa-plus": !_vm.showCart,
                      "fa-minus": _vm.showCart
                    }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex justify-content-between align-items-center"
            },
            [
              _c("div", { staticClass: "toggle-wrapper d-none d-md-block" }, [
                _c(
                  "a",
                  {
                    staticClass: "toggle-link text-dark",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        _vm.showCart = !_vm.showCart
                      }
                    }
                  },
                  [
                    _vm._v("\n                            View Order Details "),
                    _c("span", {
                      staticClass: "fa ml-1",
                      class: {
                        "fa-plus": !_vm.showCart,
                        "fa-minus": _vm.showCart
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "disclaimer d-none d-md-block" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "actions d-block d-md-flex align-items-center" },
                [
                  _c(
                    "div",
                    { staticClass: "order-items mr-1  d-none d-md-block" },
                    [
                      _c("span", { staticClass: "item-count" }, [
                        _vm._v(_vm._s(_vm.cartItemsCount) + " Items")
                      ]),
                      _vm._v(" / "),
                      _c("strong", { staticClass: "item-total" }, [
                        _vm._v(_vm._s(_vm._f("currency")(_vm.cartItemsTotal)))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex d-md-none w-100 align-items-center justify-content-between"
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "item-count font-weight-bold" },
                        [_vm._v(_vm._s(_vm.cartItemsCount) + " Items")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "item-total font-weight-bold" },
                        [_vm._v(_vm._s(_vm._f("currency")(_vm.cartItemsTotal)))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-success px-3 d-block d-md-inline-block",
                      attrs: {
                        href: "/checkout",
                        disabled: _vm.cart.length ? null : true
                      }
                    },
                    [_vm._v("Place Order")]
                  )
                ]
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }